import { render, staticRenderFns } from "./get-deposit-manually-form.vue?vue&type=template&id=ffda3f54&scoped=true"
import script from "./get-deposit-manually-form.vue?vue&type=script&lang=js"
export * from "./get-deposit-manually-form.vue?vue&type=script&lang=js"
import style0 from "./get-deposit-manually-form.vue?vue&type=style&index=0&id=ffda3f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffda3f54",
  null
  
)

export default component.exports